import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "base-picture" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]

import { localDb } from '@/store/LocalDb'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePicture',
  props: {
  name: { type: String, required: false },
  base64: { type: String, required: false },
  useUrl: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props


const BASE_URL = `${process.env.VUE_APP_API_URL}images/`

const computedBase64 = ref('')

onMounted(async () => {
  if (!props.useUrl) {
    await localDb.open()
    computedBase64.value =
      (await localDb.getItem(props.name || ''))?.base64 || ''
    await localDb.close()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", _hoisted_1, [
    (computedBase64.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: computedBase64.value,
          alt: __props.name
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.base64)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: __props.base64,
          alt: __props.name
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.useUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: `${BASE_URL}${__props.name}`,
          alt: __props.name
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})